import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useEnv } from '@zenbusiness/application-commons-env';

import { isZenDashOrigin } from '#client/hooks/isZenDashOrigin';

export const useDashboardPath = (suffix = '') => {
  const { businessEntityUuid } = useBusinessEntity();

  const { PARENT_SEGMENT = '/d' } = useEnv();

  if (isZenDashOrigin()) {
    return `${PARENT_SEGMENT}/company/${businessEntityUuid}${suffix}`;
  }

  return `${PARENT_SEGMENT}/${businessEntityUuid}${suffix}`;
};
